import { RuntimeConfig } from './types';

export type RuntimeConfigGet = {
    (): RuntimeConfig;
    <K extends keyof RuntimeConfig>(key: K): RuntimeConfig[K];
};

export function createRuntimeConfigGet(getStore: () => RuntimeConfig): RuntimeConfigGet {
    function get(): RuntimeConfig;
    function get<K extends keyof RuntimeConfig>(key: K): RuntimeConfig[K];
    function get(key?: keyof RuntimeConfig): RuntimeConfig | RuntimeConfig[keyof RuntimeConfig] {
        const config = getStore();

        if (key === undefined) {
            return config;
        }

        return config[key];
    }

    return get;
}
